import BlCapsuleAv from './BlCapsuleAv.vue'

BlCapsuleAv.install = function(Vue) {
  Vue.component(BlCapsuleAv.name, BlCapsuleAv)
}

export default BlCapsuleAv
